import { DS_DESCRIPTION } from "@/pages/portfolio-design-system/meta";

/* The description of each case study card. One text per case study, used
   wherever a card shows a description: the featured cards on the home page
   and "More Case Studies". Confirmed copy (project doc revised-copy/cards.md):
   121 to 129 characters each, so a description never takes more than four
   lines and the button of every card sits on the same line. */
export const cardDescriptions: Record<string, string> = {
  "/meta-product":
    "AI did the execution, while the story, the taste and the reason behind each choice stayed with me, because they show how I think.",
  "/portfolio-design-system": DS_DESCRIPTION,
  "/skilllab-guardians-feature":
    "With nobody to interview and 14 days to design a new role for parents, I pushed for what a parent needs to understand it.",
  "/skilllab-accessibility":
    "Accessibility had no owner and no budget. I ran my own audit, found allies and worked the fixes into what was already shipping.",
  "/skilllab-counselor-portal":
    "I redesigned a profile section with no constraints, tested it with eight counselors and defended the one change worth building.",
  "/skilllab-design-system":
    "Our design system could not carry a second brand. I took on its governance and kept only what a small team could keep alive.",
};
